/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import Vue from 'vue/dist/vue';

if (process.env.MIX_ENV_MODE === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug    = false;
    Vue.config.silent   = true;
}

window.Vue = Vue;
window.VueEvent = new Vue();

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN'     : window.Laravel.csrfToken,
    'X-Requested-With' : 'XMLHttpRequest'
};

/**
 * IE 11 Polyfill
 */
(function(w) {
    w.URLSearchParams = w.URLSearchParams || function(searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function(name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        };
    }
})(window);


/**
 * Lazy loading images
 */
import yall from "yall-js";

document.addEventListener("DOMContentLoaded", yall);